import { render, staticRenderFns } from "./SwapInvoiceOrder.vue?vue&type=template&id=203b78a6&"
import script from "./SwapInvoiceOrder.vue?vue&type=script&lang=js&"
export * from "./SwapInvoiceOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports